import React from 'react';

import Tippy from '@tippyjs/react';
import moment from 'moment';

import Button from 'components/shared/Buttons/Button';
import Icon from 'components/shared/Icon/Icon';

const UnpostClaim = ({ handleUnPostClaim = () => {}, claimId = null, createdAt }) => {
  const enabledFrom = new Date('2025-05-19T00:00:00.000Z');
  const isEnabled = moment(createdAt).isAfter(enabledFrom);

  return (
    <div className="mx-auto flex h-full items-center justify-center gap-1">
      <Button
        text="Unpost"
        onClick={() => handleUnPostClaim(claimId)}
        size="small"
        disabled={!isEnabled}
      />

      <Tippy
        content="Unposting is available for ERAs after May 19, 2025."
        className="tippy-dark"
        placement="top">
        <div>
          <Icon icon="info-circle-mono" />
        </div>
      </Tippy>
    </div>
  );
};

export default UnpostClaim;
